module.exports = __webpack_public_path__ + "static/media/profile.f287a42a.jpg";